import { Box, ColorType, useLayoutContext , Image } from "arkh";
import React from "react";
import {
  LinkedItemContainer,
  LinkedItemSubtitle,
  LinkedItemTitle,
} from "./LinkedItemContainer";
import { graphql, useFragment } from "react-relay";
import { FileIconRelay } from "../../features/Files/FileListItem/FileIcon";
import { LinkedFileItem_file$key } from "./__generated__/LinkedFileItem_file.graphql";
import { FormattedMessage } from "react-intl";

export function LinkedFileItem(props: {
  file: LinkedFileItem_file$key;
  onPress: (id: string) => void;
  onUnlink?: (id: string) => void;
  borderColor?: ColorType;
  disabled?: boolean;
}) {
  const file = useFragment(
    graphql`
      fragment LinkedFileItem_file on File {
        id
        name
        ...FileIcon_File
        pages {
          id
        }
        thumbnail {
          id
          ...Image_image
        }
      }
    `,
    props.file
  );

  const numberOfPages = file.pages?.length ?? 0;
  const layout = useLayoutContext();
  return (
    <LinkedItemContainer
      disabled={props.disabled}
      onPress={() => {
        props.onPress(file.id);
      }}
      onRemove={
        props.onUnlink
          ? () => {
              props.onUnlink?.(file.id);
            }
          : undefined
      }
      borderColor={props.borderColor}
    >
      <FileIconRelay hideOrg file={file} size={layout.icon.medium} />
      <Box spaceLeft="small" style={{ flex: 1 }}>
        <LinkedItemTitle>{file.name}</LinkedItemTitle>
        <LinkedItemSubtitle>
          {numberOfPages > 0 ? (
            <FormattedMessage
              description="LinkedFileItem number of pages"
              defaultMessage="{numberOfPages, plural, one {1 page} other {# pages}}"
              values={{
                numberOfPages,
              }}
            />
          ) : null}
        </LinkedItemSubtitle>
      </Box>
      {file.thumbnail ? (
        <Image
          type="remote"
          image={file.thumbnail}
          style={{
            width: layout.circle.medium,
            height: layout.circle.medium,
          }}
        />
      ) : null}
    </LinkedItemContainer>
  );
}
